/* Bagpacks — AJAX add-to-cart, mini-cart slide-in. Vanilla JS. */
(function () {
  'use strict';

  var money = function (cents) {
    return '£' + (Math.round(cents) / 100).toFixed(2);
  };

  var els = {};
  function cache() {
    els.minicart = document.getElementById('bp-minicart');
    els.items = document.getElementById('bp-minicart-items');
    els.foot = document.getElementById('bp-minicart-foot');
    els.subtotal = document.getElementById('bp-minicart-subtotal');
    els.cartLink = document.getElementById('cart-icon-bubble');
  }

  /* ---- header count bubble ---- */
  function setCount(count) {
    if (!els.cartLink) return;
    var bubble = els.cartLink.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      els.cartLink.appendChild(bubble);
    }
    bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>';
    bubble.style.display = count > 0 ? '' : 'none';
  }

  /* ---- mini-cart rendering ---- */
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!els.items) return;

    if (!cart.items || cart.items.length === 0) {
      els.items.innerHTML = '<p class="bp-minicart__empty">Your bag is empty.</p>';
      if (els.foot) els.foot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')
        : '';
      html +=
        '<div class="bp-mc-item">' +
        '<div class="bp-mc-item__media bp-stage">' +
        (img ? '<img src="' + img + '" alt="" width="60" height="60">' : '') +
        '</div>' +
        '<div class="bp-mc-item__info">' +
        '<a class="bp-mc-item__title" href="' + item.url + '">' + item.product_title.split(' | ')[0] + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="bp-mc-item__variant">' + item.variant_title + '</div>'
          : '') +
        '<div class="bp-mc-item__row"><span>Qty ' + item.quantity + '</span><span>' +
        money(item.final_line_price) + '</span></div>' +
        '</div>' +
        '</div>';
    });
    els.items.innerHTML = html;
    if (els.subtotal) els.subtotal.textContent = money(cart.total_price);
    if (els.foot) els.foot.hidden = false;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---- open / close ---- */
  function openCart() {
    if (!els.minicart) return;
    els.minicart.classList.add('is-open');
    els.minicart.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bp-no-scroll');
  }
  function closeCart() {
    if (!els.minicart) return;
    els.minicart.classList.remove('is-open');
    els.minicart.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bp-no-scroll');
  }

  /* ---- add to cart ---- */
  var errorTimer;
  function showError(btn, msg) {
    if (!btn) return;
    var label = btn.querySelector('span') || btn;
    if (!btn.hasAttribute('data-bp-label')) btn.setAttribute('data-bp-label', label.textContent);
    label.textContent = msg;
    clearTimeout(errorTimer);
    errorTimer = setTimeout(function () {
      label.textContent = btn.getAttribute('data-bp-label');
      btn.removeAttribute('data-bp-label');
    }, 2500);
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var data = new FormData(form);
    return fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          showError(btn, res.body && res.body.description ? res.body.description : 'Could not add to bag');
          return;
        }
        return refresh().then(openCart);
      })
      .catch(function () { showError(btn, 'Could not add to bag'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  /* ---- wiring ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-bp-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---- cart page: AJAX line edit via Section Rendering API ---- */
  function changeLine(key, quantity) {
    var root = document.querySelector('[data-bp-cart]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        var html = cart.sections && cart.sections[sectionId];
        var wrap = document.getElementById('shopify-section-' + sectionId);
        if (html && wrap) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sectionId);
          wrap.innerHTML = fresh ? fresh.innerHTML : html;
        }
        refresh();
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bp-close]')) { e.preventDefault(); closeCart(); }
    var open = e.target.closest('[data-bp-open-cart]');
    if (open) { e.preventDefault(); refresh().then(openCart); }

    var qtyBtn = e.target.closest('[data-bp-line-qty]');
    if (qtyBtn && !qtyBtn.disabled) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-key');
      var valEl = qtyBtn.parentNode.querySelector('.bp-qty__val');
      var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      var next = Math.max(0, cur + parseInt(qtyBtn.getAttribute('data-bp-line-qty'), 10));
      changeLine(key, next);
    }
    var rm = e.target.closest('[data-bp-line-remove]');
    if (rm && !rm.disabled) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  document.addEventListener('DOMContentLoaded', function () {
    cache();
    // Keep header count in sync on load
    refresh();
  });
})();
